import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-teal-50 py-8 px-4">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center text-teal-600 hover:text-teal-700 mb-6">
          <ArrowLeft className="w-4 h-4 mr-1" /> Back to Home
        </Link>
        
        <Card>
          <CardHeader>
            <CardTitle className="text-2xl">Privacy Policy</CardTitle>
            <p className="text-slate-500">Eswatini Seals Swim Academy</p>
          </CardHeader>
          <CardContent className="prose prose-slate max-w-none">
            <p className="text-sm text-slate-500">Last updated: January 2026</p>
            
            <h2 className="text-lg font-semibold mt-6 mb-3">1. Information We Collect</h2>
            <p>We collect information you provide directly to us, including:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Personal identification information (name, email address, phone number)</li>
              <li>School information (name, address, type)</li>
              <li>Student enrollment details</li>
              <li>Payment information</li>
              <li>Communication preferences</li>
            </ul>

            <h2 className="text-lg font-semibold mt-6 mb-3">2. How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Process registrations and manage programs</li>
              <li>Communicate about lessons, schedules, and updates</li>
              <li>Send promotional materials (with your consent)</li>
              <li>Improve our services and develop new programs</li>
              <li>Comply with legal obligations</li>
            </ul>

            <h2 className="text-lg font-semibold mt-6 mb-3">3. Information Sharing</h2>
            <p>
              We do not sell, trade, or rent your personal information to third parties. We may share information with:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Service providers who assist in our operations</li>
              <li>Government authorities when required by law</li>
              <li>Partners with your explicit consent</li>
            </ul>

            <h2 className="text-lg font-semibold mt-6 mb-3">4. Data Security</h2>
            <p>
              We implement appropriate security measures to protect your personal information. However, no method of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.
            </p>

            <h2 className="text-lg font-semibold mt-6 mb-3">5. Data Retention</h2>
            <p>
              We retain your information for as long as necessary to provide our services and comply with legal obligations. You may request deletion of your data at any time.
            </p>

            <h2 className="text-lg font-semibold mt-6 mb-3">6. Your Rights</h2>
            <p>You have the right to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Access your personal information</li>
              <li>Correct inaccurate information</li>
              <li>Request deletion of your information</li>
              <li>Opt out of marketing communications</li>
              <li>Lodge a complaint with relevant authorities</li>
            </ul>

            <h2 className="text-lg font-semibold mt-6 mb-3">7. Cookies</h2>
            <p>
              Our website uses cookies to enhance your experience. You can control cookie settings through your browser preferences.
            </p>

            <h2 className="text-lg font-semibold mt-6 mb-3">8. Children's Privacy</h2>
            <p>
              We collect information about minors only with parental or guardian consent. Parents/guardians have the right to review, delete, or refuse further collection of their child's information.
            </p>

            <h2 className="text-lg font-semibold mt-6 mb-3">9. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of significant changes via email or through our website.
            </p>

            <h2 className="text-lg font-semibold mt-6 mb-3">10. Contact Us</h2>
            <p>
              For questions about this Privacy Policy or our data practices, please contact us at:<br />
              Email: privacy@eswatiniseals.com<br />
              Phone: +268 7xxx xxxx
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
